import React from 'react';
import config from '../../../baseConfig';

const EmptyBox = ({ title }) => {

    return (
        <div className="main-wrapper__right-inner scroller-block pr">
            <div className="main-wrapper__empty-content tc">
                <h2 className="main-wrapper__empty-title fb fs36">{title}</h2>
                <img src={`${config.imgURLPrefix}img/empty.png?v=1`} alt={title} />
            </div>
        </div>
    );

};

export default EmptyBox;